import React from 'react'
import DoneModal from './DoneModal'
import { AnchorButton } from '../Basics'

export default ({ showExamples, showExampleLink, updateGlobalState, children, ...props }) => {
  return (
    <DoneModal {...props} lessPadding={true} buttonOverride={showExamples && 'Back'}>
      {!showExamples && showExampleLink && (
        <div>
          <AnchorButton
            onClick={() => {
              updateGlobalState({ showExamples: !showExamples })
            }}>
            See Examples
          </AnchorButton>
        </div>
      )}
      {children}
    </DoneModal>
  )
}
